/* import __COLOCATED_TEMPLATE__ from './screen-reader-announcer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();